import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconFullscreen: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M4.16797 15.8327H6.21922C6.3963 15.8327 6.54477 15.8926 6.66464 16.0125C6.78436 16.1323 6.84422 16.2808 6.84422 16.4579C6.84422 16.6351 6.78436 16.7835 6.66464 16.9031C6.54477 17.0228 6.3963 17.0827 6.21922 17.0827H3.6713C3.45783 17.0827 3.27894 17.0105 3.13464 16.866C2.99019 16.7217 2.91797 16.5428 2.91797 16.3293V13.7814C2.91797 13.6044 2.9779 13.4559 3.09776 13.336C3.21762 13.2163 3.36609 13.1564 3.54318 13.1564C3.7204 13.1564 3.8688 13.2163 3.98839 13.336C4.10811 13.4559 4.16797 13.6044 4.16797 13.7814V15.8327ZM15.8426 15.8327V13.7814C15.8426 13.6044 15.9025 13.4559 16.0223 13.336C16.1422 13.2163 16.2907 13.1564 16.468 13.1564C16.6451 13.1564 16.7935 13.2163 16.9132 13.336C17.0328 13.4559 17.0926 13.6044 17.0926 13.7814V16.3293C17.0926 16.5428 17.0204 16.7217 16.8761 16.866C16.7316 17.0105 16.5528 17.0827 16.3394 17.0827H13.7913C13.6142 17.0827 13.4658 17.0228 13.3461 16.9029C13.2262 16.783 13.1663 16.6346 13.1663 16.4575C13.1663 16.2803 13.2262 16.1318 13.3461 16.0123C13.4658 15.8925 13.6142 15.8327 13.7913 15.8327H15.8426ZM4.16797 4.16602V6.21727C4.16797 6.39435 4.10804 6.54282 3.98818 6.66268C3.86832 6.78241 3.71984 6.84227 3.54276 6.84227C3.36554 6.84227 3.21714 6.78241 3.09755 6.66268C2.97783 6.54282 2.91797 6.39435 2.91797 6.21727V3.66935C2.91797 3.45588 2.99019 3.27699 3.13464 3.13268C3.27894 2.98824 3.45783 2.91602 3.6713 2.91602H6.21922C6.3963 2.91602 6.54477 2.97595 6.66464 3.09581C6.78436 3.21567 6.84422 3.36414 6.84422 3.54122C6.84422 3.71845 6.78436 3.86685 6.66464 3.98643C6.54477 4.10615 6.3963 4.16602 6.21922 4.16602H4.16797ZM15.8426 4.16602H13.7913C13.6142 4.16602 13.4658 4.10609 13.3461 3.98622C13.2262 3.86636 13.1663 3.71789 13.1663 3.54081C13.1663 3.36358 13.2262 3.21518 13.3461 3.0956C13.4658 2.97588 13.6142 2.91602 13.7913 2.91602H16.3394C16.5528 2.91602 16.7316 2.98824 16.8761 3.13268C17.0204 3.27699 17.0926 3.45588 17.0926 3.66935V6.21727C17.0926 6.39435 17.0326 6.54282 16.9128 6.66268C16.793 6.78241 16.6446 6.84227 16.4673 6.84227C16.2901 6.84227 16.1417 6.78241 16.0221 6.66268C15.9024 6.54282 15.8426 6.39435 15.8426 6.21727V4.16602Z"
        fill={color}
      />
    </svg>
  );
};

export default IconFullscreen;
